/**
 * Small reusable inline form-field helpers extracted from
 * JobCardDetail.jsx (Wave 25.16 Phase 2 refactor — file was 2198 lines).
 *
 * Both `NumField` and `TextField` collapse to a read-only chip when
 * `isManager` is false so the JC detail page can stay a single render
 * tree across roles.
 */

export function NumField({ label, value, onChange, isManager, testid, icon: Icon, hint }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wider text-[#647087] flex items-center gap-1">
        {Icon && <Icon className="w-3 h-3" />} {label}
      </div>
      {isManager ? (
        <input
          type="number"
          step="0.5"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
          className="hv-input mt-1"
          data-testid={testid}
        />
      ) : (
        <div className="hv-input mt-1 opacity-70">{value ?? "—"}</div>
      )}
      {hint && <div className="text-[10px] text-[#647087] mt-1">{hint}</div>}
    </div>
  );
}

export function TextField({ label, value, onChange, isManager, testid, fullSpan, icon: Icon }) {
  return (
    <div className={fullSpan ? "md:col-span-3" : ""}>
      <div className="text-xs uppercase tracking-wider text-[#647087] flex items-center gap-1">
        {Icon && <Icon className="w-3 h-3" />} {label}
      </div>
      {isManager ? (
        <input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="hv-input mt-1"
          data-testid={testid}
        />
      ) : (
        <div className="hv-input mt-1 opacity-70">{value || "—"}</div>
      )}
    </div>
  );
}

/** Render hours decimal as "Hh Mm" — used in summary stats. */
export function formatHoursAsHHmm(hours) {
  if (hours == null || hours === "") return "—";
  const total = Math.max(0, Math.round(Number(hours) * 60));
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m.toString().padStart(2, "0")}m`;
}
